import { useMemo } from 'react';
import { useIntlUds } from '../../../../../translations/UdsIntlProvider';
import { DEFAULT_EXPORT_FILE_FORMATS, TIME_INTERVALS } from './QuickReports.constants';
import { FileFormat, TimeInterval } from './QuickReports.type';

export const useTranslatedFileFormatOptions = (exportFileFormats: FileFormat[]) => {
  const { intl } = useIntlUds();

  return useMemo(
    () =>
      DEFAULT_EXPORT_FILE_FORMATS.filter((value) => exportFileFormats?.includes(value)).map((value) => ({
        value,
        label: intl.DataTable.fileFormats[value]
      })),
    [exportFileFormats, intl]
  );
};

export const useTranslatedTimeIntervalOptions = (timeIntervals: TimeInterval[] = TIME_INTERVALS) => {
  const { intl } = useIntlUds();

  return useMemo(
    () => timeIntervals.map((value) => ({ value, label: intl.DataTable.timeIntervals[value] })),
    [timeIntervals, intl]
  );
};
